import sdl from '@jds/react-generated-sdl/JDSSelectorItem';
import type { JDSSelectorItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSSelectorItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    selected = false,
    stretch = false,
    kind = 'label_icon',
    wrap = 'horizontal',
    disabled = false,
    ariaLabel = props.label?.toString(),
    _ariaChecked = props.selected?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      selected,
      stretch,
      kind,
      wrap,
      disabled,
      ariaLabel,
      _ariaChecked,
      ...rest
    },
    'JDSSelectorItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SelectorItem = withLogic(Component) as React.FC<JDSSelectorItemProps> & {
  slotName?: string;
};

SelectorItem.displayName = 'SelectorItem';
SelectorItem.slotName = 'jds_selector_item';

export { SelectorItem, type JDSSelectorItemProps };
